import { mensagemPadrao } from 'src/dados-estaticos'
import { PrecificacaoCategoria } from 'src/tipos/precificacao'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  nome: Yup.string().required(mensagemPadrao),
  codigo: Yup.string().required(mensagemPadrao),
  cpf: Yup.string().notRequired(),
  // Base nunca depende de data (vale até outra base assumir). Cpf e Campanha
  // Pós sempre exigem data: Cpf para vigência da negociação individual,
  // Campanha Pós para delimitar a janela temporária sem mexer na Base.
  // Campanha Extensão só exige data quando NÃO é o valor padrão do curso -
  // marcada como padrão (precificacaoBase=true), ela vale indefinidamente
  // como a Base institucional do curso, mesma regra de Base.
  dataInicio: Yup.string().when(['categoria', 'precificacaoBase'], {
    is: (categoria, precificacaoBase) =>
      categoria === PrecificacaoCategoria.Base ||
      (categoria === PrecificacaoCategoria.CampanhaExtensao && precificacaoBase),
    then: schema => schema.notRequired(),
    otherwise: schema => schema.required(mensagemPadrao)
  }),
  dataFim: Yup.string().when(['categoria', 'precificacaoBase'], {
    is: (categoria, precificacaoBase) =>
      categoria === PrecificacaoCategoria.Base ||
      (categoria === PrecificacaoCategoria.CampanhaExtensao && precificacaoBase),
    then: schema => schema.notRequired(),
    otherwise: schema => schema.required(mensagemPadrao)
  }),
  valorBase: Yup.string().when(['categoria', 'precificacaoBase'], {
    is: (categoria, precificacaoBase) =>
      categoria === PrecificacaoCategoria.CampanhaExtensao && precificacaoBase,
    then: schema => schema.required(mensagemPadrao),
    otherwise: schema => schema.notRequired()
  }),
  pctDesconto: Yup.string().when(['categoria', 'precificacaoBase'], {
    is: (categoria, precificacaoBase) =>
      categoria === PrecificacaoCategoria.CampanhaExtensao && !precificacaoBase,
    then: schema => schema.required(mensagemPadrao),
    otherwise: schema => schema.notRequired()
  }),
  cursoId: Yup.string().required(mensagemPadrao)
})
